export const UPDATE_FEED_LIST = "act-update-feed-list";

export const updateFeedList = (feedList) => ({
  type: UPDATE_FEED_LIST,
  payload: [...feedList],
});
